/* TCR AI Parts Finder — optional popup chat that accepts a QUESTION or a PRODUCT.
   Native header/hero search is untouched; this opens only via [data-ai-finder-open].
   Deterministic: Q&A from TCR_AI_KNOWLEDGE, products from Shopify suggest API.
   Requires: vehicle-data.js (window.TCR_VEHICLES), tcr-ai-knowledge.js (optional). */
(function () {
  'use strict';
  if (!window.TCR_VEHICLES) return;
  if (window.TCR_AI_FINDER) return; // already initialized (snippet rendered twice?)
  var V = window.TCR_VEHICLES;
  var KB = window.TCR_AI_KNOWLEDGE || [];
  var ONTO = window.TCR_ONTOLOGY || [];

  /* ---------- utilities (from conversational-search core) ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = String(html == null ? '' : html).trim();
    return t.content.firstChild || document.createElement('span');
  }
  function money(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'string' && v.indexOf('.') !== -1) {
      return '$' + parseFloat(v).toFixed(2).replace(/\.00$/, '');
    }
    var n = Number(v);
    if (isNaN(n)) return '';
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }
  function vehicleLabel(p) {
    var parts = [];
    if (p.year) parts.push(p.year);
    if (p.make && V.MAKES[p.make]) parts.push(V.MAKES[p.make].name);
    if (p.model && V.MODELS[p.model]) parts.push(V.MODELS[p.model].name);
    return parts.filter(Boolean).join(' ');
  }

  /* ---------- query parser (from conversational-search core) ---------- */
  function parseQuery(raw) {
    var normalized = (' ' + raw.toLowerCase() + ' ').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ');
    var text = normalized;
    var result = { year: null, make: null, model: null, intent: raw.trim() };
    var ym = text.match(/\b(19[89]\d|20[0-2]\d)\b/);
    if (ym) result.year = parseInt(ym[1], 10);
    var bestModel = null, bestLen = 0;
    Object.keys(V.MODELS).forEach(function (key) {
      var m = V.MODELS[key];
      m.aliases.forEach(function (a) {
        if (text.indexOf(' ' + a + ' ') !== -1 && a.length > bestLen) { bestLen = a.length; bestModel = key; }
      });
    });
    if (bestModel) { result.model = bestModel; result.make = V.MODELS[bestModel].make; }
    else {
      Object.keys(V.MAKES).forEach(function (key) {
        var mk = V.MAKES[key];
        for (var i = 0; i < mk.aliases.length; i++) {
          if (text.indexOf(' ' + mk.aliases[i] + ' ') !== -1) { result.make = key; break; }
        }
      });
    }
    var intent = normalized;
    if (result.year) intent = intent.replace(new RegExp('\\b' + result.year + '\\b', 'g'), ' ');
    if (bestModel) V.MODELS[bestModel].aliases.forEach(function (a) { intent = intent.split(' ' + a + ' ').join(' '); });
    if (result.make) V.MAKES[result.make].aliases.forEach(function (a) { intent = intent.split(' ' + a + ' ').join(' '); });
    intent = intent.replace(/\b(for|my|the|a|an|parts|part|accessories|accessory)\b/g, ' ').replace(/\s+/g, ' ').trim();
    result.intent = intent;
    result.hasVehicle = !!(result.year || result.make || result.model);
    result.hasIntent = intent.length >= 2;
    return result;
  }

  /* ---------- product fetching ---------- */
  function fetchSuggestions(query, cb) {
    if (!query || query.length < 2) { cb([]); return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
    fetch(url).then(function (r) { return r.json(); })
      .then(function (d) {
        var products = (d.resources && d.resources.results && d.resources.results.products) || [];
        setTimeout(function () { cb(products); }, 0);
      })
      .catch(function () { cb([]); });
  }

  /* ---------- product card ---------- */
  function productCard(p, vehicle) {
    var img = p.featured_image && (p.featured_image.url || p.featured_image.src);
    if (img && img.indexOf('http') !== 0) img = 'https:' + img;
    var vendor = p.vendor || '';
    var showVendor = vendor && p.title.toLowerCase().indexOf(vendor.toLowerCase()) !== 0;
    var badge = (vehicle && (vehicle.make || vehicle.model))
      ? '<span class="tcr-aif-pbadge">Verify fitment for your vehicle</span>' : '';
    return '<a class="tcr-aif-product" href="' + esc(p.url) + '">' +
      (img ? '<span class="tcr-aif-pimg"><img src="' + esc(img) + '" alt="" loading="lazy"></span>' : '') +
      '<span class="tcr-aif-pinfo">' + (showVendor ? '<span class="tcr-aif-pvendor">' + esc(vendor) + '</span>' : '') +
      '<span class="tcr-aif-ptitle">' + esc(p.title) + '</span>' +
      '<span class="tcr-aif-pprice">' + esc(money(p.price)) + '</span>' + badge + '</span></a>';
  }

  /* ---------- knowledge-base matching ---------- */
  function norm(s) { return (' ' + s.toLowerCase() + ' ').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' '); }
  var STOPWORDS = { what:1, which:1, how:1, when:1, where:1, why:1, do:1, does:1, did:1, is:1, are:1,
    can:1, should:1, will:1, would:1, the:1, a:1, an:1, and:1, or:1, of:1, for:1, my:1, your:1, i:1,
    it:1, its:1, to:1, in:1, on:1, with:1, than:1, vs:1, v:1, s:1, t:1, me:1, this:1, that:1, these:1 };
  /* Human handoff: refund requests and "talk to a person" go straight to Live chat. */
  var HUMAN_PATTERNS = ['live agent', 'live chat', 'real person', 'talk to a human', 'talk to someone',
    'talk to somebody', 'speak to someone', 'speak with someone', 'customer service', 'customer support',
    'support agent', 'human', 'refund', 'phone number', 'call you', 'call me',
    'return my order', 'return an item', 'make a return', 'start a return'];
  function wantsHuman(q) {
    var t = norm(q);
    return HUMAN_PATTERNS.some(function (p) { return t.indexOf(p) !== -1; });
  }
  function contentWords(s) {
    return norm(s).trim().split(' ').filter(function (w) { return w.length > 1 && !STOPWORDS[w]; });
  }
  // IDF weights: distinctive words ("warranty", "void") outrank ubiquitous
  // ones ("intake", "brake") so ties break toward the most specific entry.
  var _idf = null;
  function idf(word) {
    if (!_idf) {
      _idf = {};
      var df = {}, n = 0;
      KB.forEach(function (entry) {
        n++;
        var seen = {};
        entry.patterns.forEach(function (pat) {
          contentWords(pat).forEach(function (w) { seen[w] = 1; });
        });
        Object.keys(seen).forEach(function (w) { df[w] = (df[w] || 0) + 1; });
      });
      Object.keys(df).forEach(function (w) { _idf[w] = Math.log(n / df[w]) + 1; });
    }
    return _idf[word] || 1;
  }
  function findAnswer(q) {
    // Word-overlap scoring with IDF weights: robust to phrasing ("will a cold
    // air intake void my warranty" matches "will intake void warranty") and to
    // hyphen variants ("semi-metallic" vs "semi metallic").
    var qWords = contentWords(q);
    if (!qWords.length) {
      // All-stopword queries ("what is this?") -> raw phrase fallback.
      var tn = norm(q);
      var hit = null;
      KB.forEach(function (entry) {
        entry.patterns.forEach(function (pat) {
          if (tn.indexOf(norm(pat).trim()) !== -1) hit = entry;
        });
      });
      return hit;
    }
    var tSet = {};
    qWords.forEach(function (w) { tSet[w] = 1; });
    var best = null, bestScore = 0;
    KB.forEach(function (entry) {
      var score = 0;
      entry.patterns.forEach(function (pat) {
        var pw = contentWords(pat);
        if (!pw.length) return;
        var hitW = 0, totW = 0;
        pw.forEach(function (w) { totW += idf(w); if (tSet[w]) hitW += idf(w); });
        var need = 2; // at least two content words must hit (or all, if fewer)
        var hitCount = 0;
        pw.forEach(function (w) { if (tSet[w]) hitCount++; });
        if (hitCount >= Math.min(pw.length, need)) score += hitW * 2 + (hitCount === pw.length ? 3 : 0);
      });
      if (score > bestScore) { bestScore = score; best = entry; }
    });
    return bestScore >= 4 ? best : null;
  }
  /* ---------- miss logging (per-browser localStorage; aggregate via backend later) ---------- */
  var MISS_KEY = 'tcr_aif_misses_v1';
  function logMiss(text, kind) {
    try {
      var log = JSON.parse(localStorage.getItem(MISS_KEY) || '[]');
      log.push({ q: text.slice(0, 200), kind: kind, at: new Date().toISOString() });
      if (log.length > 200) log = log.slice(-200);
      localStorage.setItem(MISS_KEY, JSON.stringify(log));
    } catch (e) { /* storage unavailable - skip */ }
  }
  function getMisses() {
    try { return JSON.parse(localStorage.getItem(MISS_KEY) || '[]'); }
    catch (e) { return []; }
  }
  /* ---------- ontology: "what goes with what" ---------- */
  function findRelated(query) {
    var t = norm(query);
    var best = null, bestLen = 0;
    ONTO.forEach(function (cat) {
      cat.match.forEach(function (kw) {
        if (t.indexOf(kw) !== -1 && kw.length > bestLen) { bestLen = kw.length; best = cat; }
      });
    });
    return best ? best.related : [];
  }
  function looksLikeQuestion(q) {
    var t = q.toLowerCase().trim();
    if (t.indexOf('?') !== -1) return true;
    return /^(what|which|how|when|where|why|do|does|is|are|can|should|will|difference between|tell me about)/.test(t);
  }

  /* ---------- chat UI ---------- */
  var overlay, msgs, input, opened = false, greeted = false;

  function buildModal() {
    overlay = el(
      '<div class="tcr-aif-overlay" data-aif-overlay hidden>' +
        '<div class="tcr-aif-modal" role="dialog" aria-modal="true" aria-label="AI Parts Finder">' +
          '<div class="tcr-aif-head">' +
            '<div><div class="tcr-aif-title">✨ AI Parts Finder</div>' +
            '<div class="tcr-aif-sub">Ask a question or describe the part you need</div></div>' +
            '<button type="button" class="tcr-aif-close" data-aif-close aria-label="Close">×</button>' +
          '</div>' +
          '<div class="tcr-aif-msgs" data-aif-msgs></div>' +
          '<div class="tcr-aif-chips" data-aif-chips></div>' +
          '<form class="tcr-aif-form" data-aif-form>' +
            '<input type="text" class="tcr-aif-input" data-aif-input placeholder="Ask a question or name a part…" autocomplete="off" aria-label="Ask a question or name a part">' +
            '<button type="submit" class="tcr-aif-send" aria-label="Send">➤</button>' +
          '</form>' +
        '</div>' +
      '</div>');
    document.body.appendChild(overlay);
    msgs = overlay.querySelector('[data-aif-msgs]');
    input = overlay.querySelector('[data-aif-input]');
    overlay.querySelector('[data-aif-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target.hasAttribute('data-aif-overlay')) close(); });
    var lastSubmit = { text: '', at: 0 };
    overlay.querySelector('[data-aif-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim();
      if (!v) return;
      var now = Date.now();
      if (v === lastSubmit.text && now - lastSubmit.at < 1200) return; // ignore double-submit
      lastSubmit = { text: v, at: now };
      input.value = '';
      handleUserMessage(v);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close(); });
  }

  function open(query) {
    if (!overlay) buildModal();
    overlay.hidden = false;
    document.body.classList.add('tcr-aif-lock');
    opened = true;
    if (!greeted) {
      greeted = true;
      botSay('Hi! I can <b>answer questions</b> about parts, fitment, shipping — or <b>find products</b> for you. What do you need?');
      showChips(['What oil should I use?', 'Brake pads for 2021 F-150', 'Do you offer free shipping?']);
    }
    if (typeof query === 'string' && query.trim()) { handleUserMessage(query.trim()); }
  setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove('tcr-aif-lock');
    opened = false;
  }

  function scrollDown() { msgs.scrollTop = msgs.scrollHeight; }
  function userSay(text) {
    msgs.appendChild(el('<div class="tcr-aif-msg tcr-aif-user"><span>' + esc(text) + '</span></div>'));
    scrollDown();
  }
  function botSay(html) {
    msgs.appendChild(el('<div class="tcr-aif-msg tcr-aif-bot"><div class="tcr-aif-bubble">' + html + '</div></div>'));
    scrollDown();
  }
  function typingOn() {
    msgs.appendChild(el('<div class="tcr-aif-msg tcr-aif-bot" data-aif-typing><div class="tcr-aif-bubble tcr-aif-typing"><span></span><span></span><span></span></div></div>'));
    scrollDown();
  }
  function typingOff() {
    var t = msgs.querySelector('[data-aif-typing]');
    if (t) t.remove();
  }
  function showChips(list) {
    var wrap = overlay.querySelector('[data-aif-chips]');
    wrap.innerHTML = '';
    list.forEach(function (c) {
      var b = el('<button type="button" class="tcr-aif-chip">' + esc(c) + '</button>');
      b.addEventListener('click', function () { handleUserMessage(c); });
      wrap.appendChild(b);
    });
  }
  function clearChips() { overlay.querySelector('[data-aif-chips]').innerHTML = ''; }

  function showProducts(products, vehicle, heading) {
    if (!products.length) {
      botSay('I couldn\'t find exact matches for that. Try fewer words — or browse the catalog.<div class="tcr-aif-actions"><a class="tcr-aif-link" href="/collections/all">Browse all products →</a></div>');
      showChips(['Brake pads', 'Motor oil', 'Tonneau covers']);
      return;
    }
    var h = el('<div class="tcr-aif-msg tcr-aif-bot"><div class="tcr-aif-bubble"><div class="tcr-aif-phead">' +
      esc(heading) + '</div><div class="tcr-aif-plist"></div></div></div>');
    var list = h.querySelector('.tcr-aif-plist');
    var seen = {};
    products.forEach(function (pr) {
      // Dedupe only true duplicates: same title AND same price (distinct SKUs kept).
      var key = String(pr.title || '').toLowerCase().replace(/[^a-z0-9]/g, '') + '|' + String(pr.price || '');
      if (seen[key]) return;
      seen[key] = 1;
      list.appendChild(el(productCard(pr, vehicle)));
    });
    msgs.appendChild(h);
    scrollDown();
    var rel = findRelated(lastQuery);
    if (rel.length) {
      var wrap = overlay.querySelector('[data-aif-chips]');
      wrap.appendChild(el('<span class="tcr-aif-rel-label">Pairs well with:</span>'));
      rel.forEach(function (r) {
        var b = el('<button type="button" class="tcr-aif-chip">' + esc(r.label) + '</button>');
        b.addEventListener('click', function () { handleUserMessage(r.q, { productsOnly: true }); });
        wrap.appendChild(b);
      });
    } else {
      showChips(['What oil should I use?', 'Will this fit my truck?', 'Do you offer free shipping?']);
    }
  }

  /* ---------- main router: question OR product ---------- */
  var lastQuery = '';
  function handleUserMessage(text, opts) {
    opts = opts || {};
    clearChips();
    lastQuery = text;
    userSay(text);
    typingOn();
    var p = parseQuery(text);
    var isQ = looksLikeQuestion(text);

    var HUMAN_HANDOFF = '<div class="tcr-aif-actions">Prefer a human? Click the <b>Live chat</b> button at the bottom-right of the page to talk to our team directly.</div>';
    function questionFallback() {
      logMiss(text, 'unanswered-question');
      botSay('Good question — I don\'t have a solid answer for that one yet. I can help you <b>find the right part</b> though — tell me your vehicle and what you need (e.g. "brake pads for 2021 F-150").' + HUMAN_HANDOFF);
      showChips(['Brake pads', 'Motor oil', 'Tonneau covers']);
    }
    setTimeout(function () {
      typingOff();
      var skipKB = !!opts.productsOnly;
      var human = skipKB ? false : wantsHuman(text);
      var entry = skipKB ? null : findAnswer(text);
      // Case 0: human handoff — refunds and "talk to a person" go to Live chat.
      // (The Live chat bubble is hidden while this popup is open, so tell them to close it first.)
      if (human) {
        botSay('Of course — our team will take care of that directly. <b>Close this window</b> and click the <b>Live chat</b> button at the bottom-right of the page to chat with us now.');
        showChips(['Track my order', 'What oil should I use?']);
        return;
      }
      // Case 1: knowledge-base answer. Products only shown from the entry's
      // curated `products` query — never from raw question keywords (avoids
      // junk matches like "return" -> throttle return springs).
      if (entry) {
        botSay(entry.answer);
        if (entry.products) {
          typingOn();
          fetchSuggestions(entry.products, function (products) {
            typingOff();
            var v = p.hasVehicle ? p : null;
            showProducts(products, v, 'Related products');
          });
        } else {
          showChips(entry.chips && entry.chips.length ? entry.chips : ['Brake pads', 'Motor oil', 'Tonneau covers']);
        }
        return;
      }
      // Case 2: product query
      if (p.hasIntent) {
        typingOn();
        var done = function (products) {
          typingOff();
          if (!products.length) {
            if (isQ) { questionFallback(); return; }
            logMiss(text, 'no-products');
          }
          var v = p.hasVehicle ? p : null;
          showProducts(products, v, v ? 'Top matches for your ' + vehicleLabel(v) : 'Top matches for "' + text + '"');
        };
        fetchSuggestions(p.intent, function (products) {
          if (!products.length && p.intent !== text.trim()) { fetchSuggestions(text.trim(), done); return; }
          done(products);
        });
        return;
      }
      // Case 3: question but no KB match and no product intent -> honest fallback
      if (isQ) { questionFallback(); return; }
      // Case 4: total fallback
      botSay('I didn\'t quite catch that. Try naming a part (like "cold air intake") or asking a question (like "what oil should I use?").');
      showChips(['Brake pads', 'Motor oil', 'What oil should I use?']);
    }, 350);
  }

  /* ---------- triggers ---------- */
  function bindTriggers() {
    document.querySelectorAll('[data-ai-finder-open]').forEach(function (btn) {
      if (btn.hasAttribute('data-aif-bound')) return;
      btn.setAttribute('data-aif-bound', '1');
      btn.addEventListener('click', function (e) { e.preventDefault(); if (btn.hasAttribute('data-q')) { open(btn.getAttribute('data-q')); } else { open(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindTriggers);
  else bindTriggers();
  // Re-bind for dynamically added triggers
  new MutationObserver(bindTriggers).observe(document.body, { childList: true, subtree: true });

  window.TCR_AI_FINDER = { open: open, close: close, getMisses: getMisses,
    clearMisses: function () { try { localStorage.removeItem(MISS_KEY); } catch (e) {} } };
})();
